export default "__VITE_ASSET__Ct4hXdFn__"